import { useEffect } from 'react';
import {
  hideSettingsButton,
  isSettingsButtonMounted,
  mountSettingsButton,
  onSettingsButtonClick,
  showSettingsButton,
} from '@telegram-apps/sdk-react';
import { insideTelegram, safe } from './env';

/** Поддерживает ли клиент кнопку настроек — иначе нужен свой вход в раздел. */
export function hasSettingsButton(): boolean {
  return insideTelegram() && safe(() => mountSettingsButton.isAvailable()) === true;
}

/** «Настройки» уезжают в меню клиента — в приложении лишний пункт не нужен. */
export function useSettingsButton(onOpen: () => void): void {
  useEffect(() => {
    if (!insideTelegram() || !mountSettingsButton.isAvailable()) return;

    safe(() => {
      if (!isSettingsButtonMounted()) mountSettingsButton();
    });
    safe(() => showSettingsButton());
    const off = safe(() => onSettingsButtonClick(onOpen));

    return () => {
      off?.();
      safe(() => hideSettingsButton());
    };
  }, [onOpen]);
}
